import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { AiSearchToolCallView } from "./AiSearchToolCallView";
import { AiSearchToolCallViewStore } from "../../store/AiSearchToolCallViewStore";
import { useStore } from "../../../../hooks";

export const AiSearchToolCallViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/aiSearchToolCall/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new AiSearchToolCallViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <AiSearchToolCallView aiSearchToolCallViewStore={store} />
      </PageLayout>
    </div>
  );
});
